
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(250|274|38|65)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
